import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Welcome from './pages/Welcome';
import Login from './pages/Login';
import Home from './pages/Home';
import SendParcel from './pages/SendParcel';
import Pickup from './pages/Pickup';
import Profile from './pages/Profile';
import PaymentResult from './pages/PaymentResult';
import MyOrders from './pages/MyOrders';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#07080c', color: '#8a8da4' }}>იტვირთება... / Loading...</div>;
  if (!user) return <Navigate to={"/login?redirect=" + encodeURIComponent(location.pathname + location.search)} />;
  return children;
}

// Where to go after login: only our own paths
function safeRedirect(search) {
  const r = new URLSearchParams(search).get('redirect') || '';
  return r.startsWith('/') && !r.startsWith('//') && !r.startsWith('/\\') ? r : '/home';
}

function LoggedInRedirect() {
  const location = useLocation();
  return <Navigate to={safeRedirect(location.search)} replace />;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<Welcome />} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/pickup" element={<Pickup />} />
      <Route path="/payment-result" element={<PaymentResult />} />
      <Route path="/login" element={user ? <LoggedInRedirect /> : <Login />} />
      {/* "Send a parcel" from the welcome page */}
      <Route path="/delivery" element={user ? <Navigate to="/send" replace /> : <Navigate to="/login?redirect=%2Fsend" replace />} />

      {/* Protected routes */}
      <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
      <Route path="/send" element={<ProtectedRoute><SendParcel /></ProtectedRoute>} />
      <Route path="/orders" element={<ProtectedRoute><MyOrders /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
